import {AutoAwesome, CheckCircle, Flag} from '@mui/icons-material';
import {Chip, Menu, MenuItem, Tooltip} from '@mui/material';
import {useState} from 'react';
import {StudyStatus} from '@cp/model';
import {env} from '../../config/env';

export interface StatusChangerChipProps {
  status?: StudyStatus | null;
  onStatusChange: (status: StudyStatus) => void | Promise<void>;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

export default function StatusChangerChip({
  status,
  onStatusChange,
  disabled = false,
  size = 'small',
}: StatusChangerChipProps) {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      setMenuAnchor(event.currentTarget);
    }
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleStatusChange = async (newStatus: StudyStatus) => {
    await onStatusChange(newStatus);
    handleMenuClose();
  };

  const statusIcon = status ? env.study.status[status]?.icon : env.study.unknownStatus.icon;
  const statusLabel = status ? env.study.status[status]?.label : env.study.unknownStatus.label;
  const statusColor = status ? env.study.status[status]?.color : env.study.unknownStatus.color;

  return (
    <>
      <Tooltip title="Click to change status" arrow>
        <Chip
          icon={statusIcon}
          label={statusLabel}
          onClick={handleMenuOpen}
          variant="outlined"
          size={size}
          disabled={disabled}
          sx={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            borderColor: statusColor,
            color: statusColor,
          }}
        />
      </Tooltip>
      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleMenuClose}>
        <MenuItem onClick={() => handleStatusChange(StudyStatus.GENERATED)}>
          <AutoAwesome sx={{mr: 1}} />
          Generated
        </MenuItem>
        <MenuItem onClick={() => handleStatusChange(StudyStatus.REVIEWED)}>
          <CheckCircle sx={{mr: 1}} />
          Reviewed
        </MenuItem>
        <MenuItem onClick={() => handleStatusChange(StudyStatus.FLAGGED)}>
          <Flag sx={{mr: 1}} />
          Flagged
        </MenuItem>
      </Menu>
    </>
  );
}
